export const webConstants = {
  SET: 'set',
}
